import React from "react";

const Footer = () => {
  return (
    <>
      <footer>
        <p>
          Copyright &copy; GOSTO all rights reserved. Povered by {" "}
          <a href="https://www.gayratjon.uz" target="_blank">G'ayratjon Abdijobborov</a>
        </p>
      </footer>
    </>
  );
};

export default Footer;
